import CantileverButton from 'components/CantileverButton'
import styled from 'styled-components'

export const RemoveFilterButton = styled(CantileverButton)`
  min-height: 1.5rem;
  padding: 0 0.25rem;
`
